import { Link } from "react-router-dom";
import PlatformOverview from "@/components/home/PlatformOverview";
import FinancialWorkflow from "@/components/home/FinancialWorkflow";
import SecurityCompliance from "@/components/home/SecurityCompliance";
import DashboardMock from "@/components/DashboardMock";
import { Section } from "@/components/Section";
import { ArrowRight } from "lucide-react";

export default function Platform() {
  return (
    <div data-testid="platform-page">
      <Section className="pt-28 pb-16">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-600 mb-4">Platform</div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-slate-900 leading-[1.02]">
              The operational spine behind every program.
            </h1>
            <p className="mt-5 text-lg text-slate-600 leading-relaxed max-w-xl">
              A modular stack that unifies vendor coordination, workflow automation, subscription infrastructure, and financial enablement under a single operating layer.
            </p>
            <div className="mt-8 flex gap-3">
              <Link
                to="/demo"
                data-testid="platform-book-demo-btn"
                className="inline-flex items-center gap-2 bg-slate-900 text-white rounded-full px-6 py-3.5 text-sm font-semibold hover:bg-slate-800 transition-colors"
              >
                Book a Demo <ArrowRight className="w-4 h-4" />
              </Link>
              <Link
                to="/programs"
                data-testid="platform-explore-btn"
                className="inline-flex items-center gap-2 bg-white text-slate-900 border border-slate-200 rounded-full px-6 py-3.5 text-sm font-semibold hover:bg-slate-50 transition-colors"
              >
                Explore Programs
              </Link>
            </div>
          </div>
          <div className="lg:col-span-6">
            <DashboardMock />
          </div>
        </div>
      </Section>

      <PlatformOverview />
      <FinancialWorkflow />
      <SecurityCompliance />
    </div>
  );
}
